<template src="@/templates/dashboard/charts/outstandingInvoices.html"></template>

<script>
	import Note from 'vue-graph/src/widgets/note.js'
	import Legends from 'vue-graph/src/widgets/legends.js'
	import OutstandingInvoicesCollection from "@/collections/outstandingInvoicesCollection";
	import moment from 'moment';

	export default {
		name: 'OutstandingInvoices',
		components: {
			Note, Legends
		},
		data() {
			return {
				outstandingInvoicesCollection: new OutstandingInvoicesCollection,
				countOutstandingInvoice: false,
				totalOutstandingInvoices: 0,
				totalOverdueAmount: [],
				totalNonOverdueAmount: [],
				invoiceAmounts: [0, 0],
				legendNames: [ 'Overdue', 'Not Yet Due' ],
				showSpinner: true
			}
		},
		created() {
			this.setViewHeight();
			this.getOutstandingInvoices();
		},
		methods: {
			getOutstandingInvoices() {
				let url = this.$localApiURL + this.outstandingInvoicesCollection.getRoute("fetch") + "?count=" + this.countOutstandingInvoice + "&token=" + localStorage.getItem('jwt');
				this.$http.post(url, {
					totalInvoiceValue: true
				}).
				then((response) => {
					if (response.data !== null && response.data !== {}) {
						this.outstandingInvoicesCollection.models = response.data.data;
						this.totalOutstandingInvoices = response.data.totalInvoices;
						this.overdueCalculation();
						this.performTotal();
						this.showSpinner = false;
					} else {
						this.outstandingInvoicesCollection.models = [];
					}
				}).catch((error) => {
					console.error(error);
				});
			},
			overdueCalculation() {
				this.outstandingInvoicesCollection.models.forEach(model => {
					let dueDate = moment(model.invoice_date).add(model.pay_within,'d');
					let current = moment().startOf('day');
					let overdue = moment.duration(current.diff(dueDate)).asDays();

					if ( overdue > 0 ) {
						// console.log('totalOverdueAmount');
						// console.log(model.invoice_amount_total);
						this.totalOverdueAmount.push(Math.round(model.invoice_amount_total));
					}
					else {
						// console.log('totalNonOverdueAmount');
						// console.log(model.invoice_amount_total);
						this.totalNonOverdueAmount.push(Math.round(model.invoice_amount_total));
					}
				});
			},
			performTotal() {
				this.invoiceAmounts= [this.totalOverdueAmount.reduce((total, initial) => total + initial, 0), this.totalNonOverdueAmount.reduce((total, initial) => total + initial, 0)];
			},
			dataFormat(a, b) {
				if(b > 0) {
					return '$' + b;
				}
				else {
					return '$' + a;
				}
			},
			setViewHeight() {
				this.chartHeight = (window.innerHeight - 290) / 2;
			}
		}
	}
</script>

<style scoped>
	.allGradsCursor >>> svg {
		background: #f5f7fa !important;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/charts/OutstandingInvoices.vue